export default __webpack_public_path__ + "static/media/_DSC2032.f8b85baf.jpg";